import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCmTrackingDates } from "../../api/reportsApi";

function toDateInput(dateStr: string | null | undefined): string {
  if (!dateStr) return "";
  return dateStr.slice(0, 10);
}

export function CmTrackingDates({
  reportId,
  cmAnalysisDate,
  cmReportDate,
  cmPmVerificationDate,
  sentToSponsorDate,
  tmfDate,
}: {
  reportId: string;
  cmAnalysisDate: string | null;
  cmReportDate: string | null;
  cmPmVerificationDate: string | null;
  sentToSponsorDate: string | null;
  tmfDate: string | null;
}) {
  const queryClient = useQueryClient();

  const [analysisVal, setAnalysisVal] = useState(toDateInput(cmAnalysisDate));
  const [reportVal, setReportVal] = useState(toDateInput(cmReportDate));
  const [pmVerificationVal, setPmVerificationVal] = useState(toDateInput(cmPmVerificationDate));
  const [sponsorVal, setSponsorVal] = useState(toDateInput(sentToSponsorDate));
  const [tmfVal, setTmfVal] = useState(toDateInput(tmfDate));

  const { mutate: save, isLoading } = useMutation(
    () =>
      updateCmTrackingDates(reportId, {
        cmAnalysisDate: analysisVal || null,
        cmReportDate: reportVal || null,
        cmPmVerificationDate: pmVerificationVal || null,
        sentToSponsorDate: sponsorVal || null,
        tmfDate: tmfVal || null,
      }),
    {
      onSuccess: () => queryClient.invalidateQueries([reportId, "Report"]),
    }
  );

  const labelCls =
    "block text-[11px] font-medium text-[var(--sc-muted)] uppercase tracking-[0.05em] mb-1";
  const inputCls =
    "w-full rounded-lg border border-[var(--sc-border)] px-3 py-2 text-[13px] text-[var(--sc-text)] bg-[var(--sc-surface)] focus:outline-none focus:ring-1 focus:ring-[#F4A832] transition-shadow";

  return (
    <div className="rounded-[10px] border border-[var(--sc-border)] bg-[var(--sc-surface)] px-5 py-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[13px] font-semibold text-[var(--sc-text)]">
          Śledzenie dokumentacji CM
        </p>
        {isLoading && (
          <span className="text-[10px] text-[var(--sc-muted)]">Zapisywanie…</span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={labelCls}>Data przygotowania analizy</label>
          <input
            type="date"
            value={analysisVal}
            onChange={(e) => setAnalysisVal(e.target.value)}
            onBlur={() => save()}
            className={inputCls}
          />
        </div>
        <div>
          <label className={labelCls}>Data sporządzenia raportu CM</label>
          <input
            type="date"
            value={reportVal}
            onChange={(e) => setReportVal(e.target.value)}
            onBlur={() => save()}
            className={inputCls}
          />
        </div>
        <div>
          <label className={labelCls}>Data weryfikacji przez PM</label>
          <input
            type="date"
            value={pmVerificationVal}
            onChange={(e) => setPmVerificationVal(e.target.value)}
            onBlur={() => save()}
            className={inputCls}
          />
        </div>
        <div>
          <label className={labelCls}>Data przekazania do Sponsora</label>
          <input
            type="date"
            value={sponsorVal}
            onChange={(e) => setSponsorVal(e.target.value)}
            onBlur={() => save()}
            className={inputCls}
          />
        </div>
        <div>
          <label className={labelCls}>Data archiwizacji w eTMF</label>
          <input
            type="date"
            value={tmfVal}
            onChange={(e) => setTmfVal(e.target.value)}
            onBlur={() => save()}
            className={inputCls}
          />
        </div>
      </div>
    </div>
  );
}
